import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { getCurrentDate, getCurrentTime } from "../utils/getCurrentDate";
import { setCredentials } from "../slices/authSlice";
import { useGetAllGymsQuery } from "../slices/gymSlice";
import { openWhatsApp } from "../utils/generalUtilities";
import { IoLogoWhatsapp } from "react-icons/io";

const ExpiredGymDetails = () => {
  const [searchBy, setSearchBy] = useState("Gym Id");
  const [searchValue, setSearchValue] = useState("");
  const { userInfo } = useSelector((state) => state.auth);
  const [startDate, setStartDate] = useState(getCurrentDate());

  const [endDate, setEndDate] = useState(getCurrentDate());

  const [getApiQuery, setGetApiQuery] = useState(
    `?createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=createdAt`
  );

  const filterOptions = ["Gym Id", "Txn Id"];

  const dispatch = useDispatch();

  const searchOptions = {
    "Gym Id": "gymId",
    "Txn Id": "transactionId",
  };
  let {
    data: allGyms,
    isLoading,
    refetch,
    error,
  } = useGetAllGymsQuery({
    token: userInfo?.token,
    query: getApiQuery,
  });

  const [pendingsToList, setPendingsToList] = useState(
    isLoading ? [] : allGyms ? allGyms : []
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    const gms = isLoading ? [] : allGyms ? allGyms : 0;
    const tmpData = gms.filter(
      (gm) => new Date(gm.subsExpiryDate) < new Date()
    );
    tmpData.sort(
      (a, b) => new Date(b.subsExpiryDate) - new Date(a.subsExpiryDate)
    );
    setPendingsToList(tmpData);
  }, [isLoading, allGyms]);

  const handleGetUsers = async () => {
    if (startDate > getCurrentDate())
      toast.error("Start date can not be greater than today");
    else if (startDate > endDate)
      toast.error("Start date can not be greater than End date");
    else {
      if (endDate?.split("T")[0] > getCurrentDate())
        setEndDate(getCurrentDate() + getCurrentTime());
      setGetApiQuery(
        `?createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=createdAt`
      );
      dispatch(
        setCredentials({
          ...userInfo,
          paymentStartDate: startDate,
          paymentEndDate: endDate,
        })
      );
    }
  };

  const navigate = useNavigate();
  const handleRenewSubscription = async (customer) => {
    navigate("/renewSubscription", {
      state: { gymDetails: customer },
    });
  };

  return (
    <>
      <strong>Expired Gyms List</strong>

      <Row
        className="mb-1"
        style={{
          justifyContent: "center",
          margin: "auto",
          width: "95%",
          alignItems: "center",
        }}
      >
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-23"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-27"
              value={endDate?.split("T")[0]}
              onChange={(e) => setEndDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6} className="d-flex justify-content-center">
          <Form.Group className="my-1" controlId="gymType">
            <Button onClick={handleGetUsers}>Get Gyms</Button>
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6} className="d-flex justify-content-center">
          <span style={{ color: "green" }}>
            <strong> Total : {pendingsToList?.length}</strong>
          </span>
        </Col>
      </Row>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message>{error.data.error}</Message>
      ) : (
        <div>
          <Table
            striped
            bordered
            hover
            responsive="sm"
            style={{ marginTop: "2rem" }}
          >
            <thead>
              <tr key="table-header">
                <th>Gym Id</th>
                <th>Gym Name</th>
                <th>Mobile </th>
                <th style={{ textAlign: "left" }}>Address</th>
                <th>Joined</th>
                <th>Renewed</th>
                <th>Expiry</th>
                <th style={{ textAlign: "left" }}>Att</th>
                <th style={{ textAlign: "left" }}>Subs</th>
                <th style={{ textAlign: "left" }}>WhatsApp</th>
              </tr>
            </thead>
            {pendingsToList ? (
              <tbody>
                {pendingsToList.map((gym) => (
                  <tr key={gym._id}>
                    <td>
                      {gym._id} <br></br>
                      <br></br>
                      {"Rs."}
                      {gym.subsAmount}{" "}
                      <span
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={(e) => handleRenewSubscription(gym)}
                      >
                        Renew
                      </span>
                    </td>
                    <td>{gym.name}</td>
                    <td>
                      {gym.primaryContact}

                      <button
                        style={{
                          border: "none",
                          color: "green",
                          background: "transparent",
                          padding: "0px",
                          cursor: "pointer",
                          margin: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={(e) =>
                          openWhatsApp(
                            gym.primaryContact,
                            "expiredMembersMessage",
                            null,
                            new Date(gym.subsExpiryDate)
                              ?.toISOString()
                              ?.split("T")[0],
                            gym.name
                          )
                        }
                      >
                        <IoLogoWhatsapp />
                      </button>
                    </td>
                    <td style={{ textAlign: "left" }}>{gym.address}</td>
                    <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                      {gym?.createdAt &&
                        new Date(
                          new Date(gym?.createdAt)?.getTime() +
                            1000 * 60 * 60 * 5.5
                        )
                          .toISOString()
                          .toString()
                          .split("T")[0]
                          .slice(0, 16)}
                    </td>
                    <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                      {gym?.subsRenewedDate &&
                        new Date(
                          new Date(gym?.subsRenewedDate)?.getTime() +
                            1000 * 60 * 60 * 5.5
                        )
                          .toISOString()
                          .toString()
                          .split("T")[0]
                          .slice(0, 16)}
                    </td>

                    <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                      {" "}
                      {new Date(
                        new Date(gym?.subsExpiryDate)?.getTime() +
                          1000 * 60 * 60 * 5.5
                      )
                        .toISOString()
                        .toString()
                        .split("T")[0]
                        .slice(0, 16)}
                    </td>
                    <td style={{ textAlign: "left" }}>{gym.attendanceCount}</td>
                    <td style={{ textAlign: "left" }}>{gym.subsCount}</td>
                    <td style={{ textAlign: "left" }}>{gym.WsMessageCount}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <Message>No Gyms Available</Message>
            )}
          </Table>
        </div>
      )}
    </>
  );
};

export default ExpiredGymDetails;
